import i18next from 'i18next';

import * as config from '../config/i18n';

import date from './date';
import languageDetector from './language-detector';
import translationLoader from './translation-loader';
// ns: config.namespaces,
// defaultNS: config.defaultNamespace,
// <Header>{t("app:おかえりなさい")}</Header>
import { initReactI18next, useTranslation } from 'react-i18next';
  
  //   const [isI18nInitialized, set_isI18nInitialized] = useState(false);

  //   useEffect(() => {
  //     i18n
  //       .init()
  //       .then(() => {
  //         set_isI18nInitialized(true);
  //       })
  //       .catch((error) => console.warn(error));
  //   }, []);

  //   if (isI18nInitialized) {
  //     return (
  //       <>
  //         <Material />
  //       </>
  //     );
  //   }
  //   return <></>;

const i18n = {
	/**
	 * @returns {Promise}
	 */
	init: () => {
		return new Promise((resolve, reject) => {
			i18next
				.use(initReactI18next)
				.use(languageDetector)
				.use(translationLoader)
				.init(
					{
						// fallbackLng: config.fallback,
						// ns: config.namespaces,
						// defaultNS: config.defaultNamespace,
						interpolation: {
							escapeValue: false,
							format(value, format) {
								if (value instanceof Date) {
									return date.format(value, format);
								}
							},
						},
					},
					(error) => {
						if (error) {
							return reject(error);
						}
						date.init(i18next.language)
							.then(resolve)
							.catch((error) => reject(error));
					}
				);
		});
	},

	t: (key, options) => i18next.t(key, options),

	get locale() {
		return i18next.language;
	},

	get dir() {
		return i18next.dir().toUpperCase();
	},
	select(map) {
		const key = this.isRTL ? 'rtl' : 'ltr';

		return map[key];
	},
};

export const t = i18n.t;

export default i18n;
